<template>
    <div class="menu">
        <router-link class="logo" exact to="/">
            <img class="logoimg" src="/api/logo.png"/>
            <div class="logo-text">
                <span class="kennel full-text"><localized-string val="menu.organization.name.1"/>
                        <span class="h3"><br><localized-string val="menu.organization.name.2"/></span>
                </span>
                <span class="kennel short-text">
                    <localized-string val="menu.organization.name.short"/><span class="h3"></span>
                </span>
            </div>
        </router-link>

        <router-link class="menu-item home" exact to="/"><localized-string val="menu.about"/></router-link>
        <!--                <router-link class="menu-item" to="/trail/next">Next Trail</router-link>-->
        <router-link class="menu-item" to="/trailhistory/"><localized-string val="menu.trails"/></router-link>
        <router-link class="menu-item" to="/runners"><localized-string val="menu.runners"/></router-link>
        <router-link class="menu-item" to="/localkennels">
            <localized-string class="full-text" val="menu.nearby"/>
            <localized-string class="short-text" val="menu.nearby.short"/>
        </router-link>
        <div class="signIn"  :class="{signedIn : this.$auth.loggedIn}" @click="signIn">
            <span class="signIn_circle_icon" alt="Sign In" :title="this.$auth.loggedIn ? this.$auth.username : 'Sign In'">account_circle</span>
            <span class="username">{{loggedInUser || 'Sign In'}}</span>
        </div>
        <GenericModal ref="loginModal" v-show="showLoginModal" @close="showLoginModal = false"/>
    </div>
</template>

<script>
    import Vue from 'vue';
  import LocalizedString from "./localizedString";
  export default {
    name: 'Menu',
    components: {LocalizedString},
    data() {
      return {showLoginModal : false};
    },
    computed: {
      loggedInUser() {
        return this.$auth.username;
      }
    },
    methods: {
      signIn() {
        this.showLoginModal = true;
        Vue.nextTick(this.$refs.loginModal.focus);
      }
    }
  }
</script>
<style lang="scss">

    .logoimg {
        height: 48px;
    }

    .logo {
        text-decoration-line: none;
        display: flex;
        height: 100%;
        /*flex-shrink: 0;*/
        /*justify-content: space-evenly;*/
        align-items: center;
        @media only screen and (max-width: 768px) {
            /*margin: 0 0.5em 0 0.5em;*/
        }

        .logo-background {
            //background-color: #d99dff;
            /*background-color: white;
            height: $title-height;
            width: $title-height;
            /*display: flex;*/
            /*align-items: center;*/
            /*justify-content: center;*/
            /*border-radius: 500px;
            border-color: $beaverpurple;
            border-width: 0.25em;
            border-style: solid;    */
        }
    }

    .logo-text {
        white-space: nowrap;
        overflow: visible;
        line-height: 1.15;
        color: white;
        font-family: 'Fontdiner Swanky',serif;
        text-align: center;
        display: flex;
        align-items: center;
        margin: 0 0.5em 0 0.5em;
        /*.kennel {*/
        /*    font-size:15px;*/
        /*}*/
        /*.h3 {*/
        /*    margin-left: 0.17em;*/
        /*    font-size: 34px;*/
        /*    font-family: "Arial Black", Gadget, sans-serif;*/
        /*    margin-bottom: 2px;//Manual vertical center*/
        /*}*/
        .kennel {
            font-size: 24px;
        }
        .h3 {
            font-size:18px;
            /*margin-left: 0.17em;*/
            /*font-size: 34px;*/
            /*font-family: "Arial Black", Gadget, sans-serif;*/
            /*margin-bottom: 2px;//Manual vertical center*/
        }

    }

    .signIn {
        cursor: pointer;
        font-size: 12px;
        color: white;
        display: flex;
        align-items: center;
    }

    .signIn_circle_icon {
        font-family: 'Material Icons';
        text-decoration: none;
        user-select: none;
        outline: none;
        font-size: 24px;
        padding: 4px;
        cursor: pointer;
        z-index: 1;
    }
    .username {
        //TODO wrap for long names
        width: 4em;
      margin-right: 1em;
    }
    .signIn.signedIn > .signIn_circle_icon {
        color: blueviolet;

    }
    .short-text {
        display: none;
    }
    .menu {
        padding: 0 1em 0 1em;
        display: flex;
        align-items: center;
        justify-content: space-around;
        //height: 3em;
        box-sizing: border-box;
        //background: linear-gradient(to right, $beaverpurple 0%, $beaverpurple 50%, rgba(255,255,255,1) 100%);
        //background-color: $beaverpurple;
    }



    #menubar {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        align-content: center;

    }
    .logo {
        margin: 0 1.5rem 0 0;
    }
    .signIn {
        margin: 0 0.5rem 0 1.5rem;
    }
    .menu-item {
        font-size: 20px;
        font-weight: bold;
        flex-grow: 1;
        max-width: 8em;
        //height: 100%;
        color: white;
        text-decoration-line: none;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        margin: 0 1.5rem 0 1.5rem;
        /*text-transform: uppercase;*/
    }
    .menu-item:hover,.menu-item:active {
        color: grey;
    }
    .menu-item.router-link-active {
        height: calc(100% - 6px);
        margin-top: 3px;
        //margin-bottom: 1px;
        box-sizing:border-box;
        border-bottom-color: white;
        border-bottom-width: 3px;
        border-bottom-style: solid;
        color: white;
    }

    @media only screen and (max-width: 1024px) {
        .signIn {
            .username {
                display: none
            }
        }
    }

    @media only screen and (max-width: 868px) {
        //Make globally smaller
        .menu-item {
            font-size: 18px;
        }
        .short-text {
            display: initial;
        }
        .full-text {
            display: none;
        }
        .menu {
            margin-top: 0;
        }
        //Remove/alter specific items
        .header {
            padding: 0.5em 0.25em;
            margin: 0;
            width: 100%;
        }
        .logoimg {
            height: 32px;
        }
        .logo-text {
            display: none;
        }
        .menu-item.home {
            display: none;
        }
    }
    @media only screen and (max-width: 568px) {
        .header {
            width: 100%;
        }


    }
    @media only screen and (max-width: 420px) {
        .header {
            width: 100%;
        }
        .menu-item {
            margin: 0 0.5rem 0 0.5rem;
        }
        .logo {
            margin: 0 0.5rem 0 0;
        }
        .signIn {
            margin: 0 0 0 0.5rem;
        }
    }


</style>
